import { StringMap } from "../../components";
import { vars } from "../../assets";

export interface SupportIncidentsProps {
  search: string;
  filters: StringMap;
  setExportDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  isAdmin: boolean;
  onOpenDetail?: (incident: AdminIncidentProps) => void;
}

export type IncidentType =
  | "supportAndHelp"
  | "technicalMaintenance"
  | "logistics"
  | "administrative"
  | "security";
export type IncidentStatusType = "answered" | "sent" | "completed" | "rejected";

export const INCIDENT_TYPES: IncidentType[] = [
  "supportAndHelp",
  "technicalMaintenance",
  "logistics",
  "administrative",
  "security",
];

export const INCIDENT_STATUSES: IncidentStatusType[] = [
  "sent",
  "answered",
  "completed",
  "rejected",
];

export interface IncidentResponseProps {
  id: number;
  fromRequester: boolean; // la escribió el solicitante (si no, el soporte)
  message: string | null;
  status: IncidentStatusType | null;
  date: string;
  authorEmail: string;
}

export interface IncidentProps {
  id: number;
  reference: string; // identificador de soporte, p.ej. "SOP-000123"
  lastUpdate: string; // última modificación (orden del listado)
  unread: boolean; // hay mensajes no leídos para quien consulta
  type: IncidentType;
  name: string;
  email: string;
  phone?: string | null;
  description: string;
  status: IncidentStatusType;
  date: string;
  responses: IncidentResponseProps[];
}

export interface AdminIncidentProps extends IncidentProps {
  requesterEmail: string;
}

export const getIncidentStatusColors = (
  status: IncidentStatusType
): { primary: string; secondary: string } => {
  switch (status) {
    case "answered":
      return { primary: "#1FC16B", secondary: "#1FC16B1A" };
    case "completed":
      return { primary: "#FFFFFF", secondary: "#1FC16B" };
    case "rejected":
      return { primary: "#D00416", secondary: "#FB37481A" };
    case "sent":
      return { primary: "#4A4A4A", secondary: "#DFB40033" };
    default:
      return { primary: vars.colorBlack, secondary: vars.colorWhiteMedium };
  }
};
